import React, {useState} from 'react';
import IModal from "../../../../../components/Admin/Modal/IModal";
import {Button, Grid, OutlinedInput, Typography} from "@mui/material";
import infoIcon from "../../../../../assets/images/admin/info_pic.png";
import Divider from "@mui/material/Divider";
import IModalBody from "../../../../../components/Admin/Modal/IModalBody";
import TextInput from "../../../../../components/Admin/TextInput/TextInput";
import {addNewPlanApi, updatePlanApi} from "../../../../../api/AdminApi";
import {errorMessage, successMessage} from "../../../../../tools/messages";
import {fixStringToTextView} from "../../../../../tools/helper";

const ModalAddProgram = ({open, close, planItem, invalidateData = undefined}) => {
    const [activePlan, setActivePlan] = useState(planItem)

    const onSubmitHandler = async () => {
        try {
            if (activePlan?.name?.length < 3 || !activePlan?.name) {
                errorMessage('اسم را وارد کنید');
                return false
            }

            let {name, description, id: plan_id} = {...activePlan};
            let reqData = {name, description, plan_id};

            let res = activePlan?.id ? await updatePlanApi(reqData) : await addNewPlanApi(reqData);
            // successMessage(res?.data?.msg);
            successMessage('با موفقیت انجام شد');
            await invalidateData();
        } catch (e) {
            // logg error
        }

        close()

    }

    return (
        <IModal width={300} showClose open={open} handleClose={close}>
            <Grid item>
                <img src={infoIcon} width={70} alt={''}/>
            </Grid>
            <Divider sx={{my: 1}}/>
            <IModalBody xs={10} md={4}>
                <Grid>
                    <Grid

                        sx={{display: "flex", justifyContent: "space-around", alignItems: "center"}}>
                        <TextInput
                            value={fixStringToTextView(activePlan?.name) ?? ''}
                            onChange={e => setActivePlan({...activePlan, name: e?.target?.value})}
                            sx={{
                                ml: 0,
                                borderRadius: "25px",
                                direction: "ltr",
                                backgroundColor: "#F9F9FB",
                                '&.MuiOutlinedInput-root.Mui-focused fieldset': {
                                    borderColor: "#974EC3",

                                },
                            }}/>
                        <Typography>
                            نام برنامه
                        </Typography>

                    </Grid>
                    <OutlinedInput
                        value={fixStringToTextView(activePlan?.description) ?? ''}
                        onChange={e => setActivePlan({...activePlan, description: e?.target?.value})}
                        placeholder="متن پاسخ خود را بنویسید..."
                        sx={{
                            direction: "ltr",
                            flexGrow: 1, my: 2, background: '#F9F9FB',
                            borderRadius: "25px",
                            width: "100%",
                            '&.MuiOutlinedInput-root.Mui-focused fieldset': {
                                borderColor: "#974EC3",

                            },
                        }}
                        multiline={true}
                        id="outlined-multiline-flexible"
                        inputProps={{sx: {minHeight: 100}}}
                    />
                    <Button onClick={onSubmitHandler}
                            sx={{background: "#592EA9", my: 2, borderRadius: "18px", padding: "8px 40px"}}
                            variant={'contained'}>ثبت تغییرات</Button>
                </Grid>

            </IModalBody>
        </IModal>
    );
};

export default ModalAddProgram;